module.exports = __webpack_public_path__ + "static/food-25bb4ed53dd45fb2b945352dcc8a4aa0.png";